var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.stateClasses,on:{"click":_vm.updateValue}},[_c('span',[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.modelValue === _vm.value},on:{"change":_vm.updateValue}})]),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }